import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';

// Layout route for every certifications screen, so the read permission is
// asked once here rather than on each child route.
export const Route = createFileRoute('/(client)/certifications/(pages)')({
  beforeLoad: async () => {
    const perms = await ensurePermissions();
    if (!perms.certificates.canRead) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: () => <Outlet />,
});
